import { render, staticRenderFns } from "./DocumentImageUpload.vue?vue&type=template&id=c764729a&scoped=true"
import script from "./DocumentImageUpload.vue?vue&type=script&lang=ts"
export * from "./DocumentImageUpload.vue?vue&type=script&lang=ts"
import style0 from "./DocumentImageUpload.vue?vue&type=style&index=0&id=c764729a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c764729a",
  null
  
)

export default component.exports